module.exports = __webpack_public_path__ + "assets/5-recruiters-for-enterprise-account-executive-jobs.3abe2455.png";